import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import OpalHeading from '../../../../components/opal/OpalHeading'

function PageHeading ({ title, size, className, style, children }) {
  return (
    <div className={clsx('flex flex-row justify-between items-center', className)} style={style}>
      <OpalHeading className={`font-serif font-size-${size}`}>{title}</OpalHeading>
      <div className='flex flex-row gap-sm'>
        {children}
      </div>
    </div>
  )
}

PageHeading.propTypes = {
  title: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl']),
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
}

PageHeading.defaultProps = {
  size: 'xl'
}

export default PageHeading
